export const getOperatorOptions = dataType => {
	const type = dataType?.toLowerCase() || 'string'

	const commonOperators = [
		{ text: 'Equals', value: '=' },
		{ text: 'Not Equals', value: '<>' },
		{ text: 'Is Blank', value: 'IS' },
		{ text: 'Is Not Blank', value: 'IS NOT' }
	]

	if (type === 'string' || type === 'text') {
		return [
			...commonOperators,
			{ text: 'Contains', value: 'LIKE' },
			{ text: 'Does Not Contain', value: 'NOT LIKE' },
			{ text: 'In List', value: 'IN' },
			{ text: 'Not In List', value: 'NOT IN' }
		]
	} else if (type === 'number' || type === 'integer' || type === 'decimal') {
		return [
			...commonOperators,
			{ text: 'Less Than', value: '<' },
			{ text: 'Less Than or Equal', value: '<=' },
			{ text: 'Greater Than', value: '>' },
			{ text: 'Greater Than or Equal', value: '>=' },
			{ text: 'Between', value: 'BETWEEN' },
			{ text: 'Not Between', value: 'NOT BETWEEN' },
			{ text: 'In List', value: 'IN' },
			{ text: 'Not In List', value: 'NOT IN' }
		]
	} else if (type === 'date' || type === 'datetime') {
		return [
			...commonOperators,
			{ text: 'Before', value: '<' },
			{ text: 'Before or On', value: '<=' },
			{ text: 'After', value: '>' },
			{ text: 'After or On', value: '>=' },
			{ text: 'Between', value: 'BETWEEN' },
			{ text: 'Not Between', value: 'NOT BETWEEN' }
		]
	}

	return commonOperators
}

export const getFieldIcon = typeFriendlyName => {
	const iconMap = {
		text: 'mdi-text',
		number: 'mdi-numeric',
		date: 'mdi-calendar',
		boolean: 'mdi-toggle-switch',
		guid: 'mdi-identifier',
		// Add more mappings as needed
		string: 'mdi-text',
		integer: 'mdi-numeric',
		decimal: 'mdi-numeric',
		float: 'mdi-numeric',
		double: 'mdi-numeric',
		int: 'mdi-numeric',
		long: 'mdi-numeric',
		short: 'mdi-numeric',
		byte: 'mdi-numeric',
		bool: 'mdi-toggle-switch',
		datetime: 'mdi-calendar-clock',
		timestamp: 'mdi-calendar-clock',
		time: 'mdi-clock-outline',
		uuid: 'mdi-identifier',
		email: 'mdi-email-outline',
		url: 'mdi-link-variant',
		phone: 'mdi-phone-outline',
		varchar: 'mdi-text',
		char: 'mdi-text',
		nvarchar: 'mdi-text',
		nchar: 'mdi-text',
		binary: 'mdi-file-outline',
		varbinary: 'mdi-file-outline',
		image: 'mdi-image-outline',
		xml: 'mdi-code-tags',
		json: 'mdi-code-braces'
	}

	const type = typeFriendlyName?.toLowerCase() || 'text'
	return iconMap[type] || 'mdi-database'
}

export const getFilterPreview = (operator, fieldDisplayName, singleValue, rangeValues, multiValues) => {
	switch (operator) {
		case '=':
			return `${fieldDisplayName} equals "${singleValue}"`
		case '<>':
			return `${fieldDisplayName} not equals "${singleValue}"`
		case '<':
			return `${fieldDisplayName} less than "${singleValue}"`
		case '<=':
			return `${fieldDisplayName} less than or equal to "${singleValue}"`
		case '>':
			return `${fieldDisplayName} greater than "${singleValue}"`
		case '>=':
			return `${fieldDisplayName} greater than or equal to "${singleValue}"`
		case 'LIKE':
			return `${fieldDisplayName} contains "${singleValue}"`
		case 'NOT LIKE':
			return `${fieldDisplayName} does not contain "${singleValue}"`
		case 'BETWEEN':
			return `${fieldDisplayName} between "${rangeValues[0]}" and "${rangeValues[1]}"`
		case 'NOT BETWEEN':
			return `${fieldDisplayName} not between "${rangeValues[0]}" and "${rangeValues[1]}"`
		case 'IN':
			return `${fieldDisplayName} in [${multiValues.join(', ')}]`
		case 'NOT IN':
			return `${fieldDisplayName} not in [${multiValues.join(', ')}]`
		case 'IS':
			return `${fieldDisplayName} is blank`
		case 'IS NOT':
			return `${fieldDisplayName} is not blank`
		default:
			return ''
	}
}

export const validateFilter = (operator, singleValue, rangeValues, multiValues) => {
	if (!operator) return false

	const isNoValueOperator = ['IS', 'IS NOT'].includes(operator)
	const isSingleValueOperator = ['=', '<>', '<', '<=', '>', '>=', 'LIKE', 'NOT LIKE'].includes(operator)
	const isRangeOperator = ['BETWEEN', 'NOT BETWEEN'].includes(operator)
	const isMultiValueOperator = ['IN', 'NOT IN'].includes(operator)

	if (isNoValueOperator) return true

	if (isSingleValueOperator) {
		return singleValue !== ''
	}

	if (isRangeOperator) {
		return rangeValues[0] !== '' && rangeValues[1] !== ''
	}

	if (isMultiValueOperator) {
		return multiValues.length > 0
	}

	return false
}
